import React, {useState, useEffect, useContext} from "react"
// context
import {CatalogueContext} from "../../../../context";
// components
import { ActivityPackageLink, Accordeon} from "../../../controls";

// styling
import "./IncludedInPackages.scss";

// the component
export default function ActivityPackages({activity}) {
  // context
  const CC = useContext(CatalogueContext);

  // state
  const [activityPackages, setActivityPackages] = useState([]);

  useEffect(() => {
    if(CC.isReady) {
      const activityPackages = CC.activityPackages.filter(ap => {
        return ap.activities.some(a => a.activityId === activity._id);
      })
      setActivityPackages(activityPackages);
    }
  }, [CC.isReady, CC.activityPackages, activity]);

  
  // no packages? no render
  if(activityPackages.length === 0) {
    return null;
  }

  // pre-render
  let explanation = "";
  if(activityPackages.length === 1) {
    explanation = "Dieses Erlebnis ist auch in folgender Erlebnis-Kombination enthalten";
  }
  else {
    explanation = "Dieses Erlebnis ist auch in folgenden Erlebnis-Kombinationen enthalten";
  }
  const items = activityPackages.map(ap => <ActivityPackageLink key={ap._id} activityPackage={ap} />);
  
  // render
  return (
    <Accordeon title="Erlebnis-Kombinationen">
      <div className="c-activity-activitypackages">
        <div className="explanation">{explanation}</div>
        <div className="items">
          {items}
        </div>
      </div>
    </Accordeon>
  )
}

